import ActivityTypeIcon from '@/shared/ActivityTypeIcon/ActivityTypeIcon';
import { StyledTaskActivityNav } from './TaskActivityNav.styled';
import Link from 'next/link';
import Colors from '@/constants/Colors';
import { pxToVw } from '@/modules/styled/cssUnits';
import Text from '@/shared/Typography/Text';
import { Check } from '@styled-icons/boxicons-regular';
import typeLabel from '@/constants/ActivityTypeLabelsStudents';
import ProgressFeedback from '@/shared/ProgressFeedback/ProgressFeedback';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { useContext } from 'react';
import { getLevelLabel } from '@/constants/ActivityLevelLabels';
import { Tag } from 'antd';
import getTaskActivityURL from '@/modules/activities/getTaskActivityURL';

export default function TaskActivityNav({
  taskActivities,
  currentTaskActivityId,
  currentActivityId,
  currentMiniactivityType,
  taskId,
  dueDate,
}) {
  const globalContext = useContext(GlobalContext);
  const timeOffset = globalContext.state.user?.student?.data?.timeOffset;

  return (
    <StyledTaskActivityNav>
      <div className="task-activity-links">
        {taskActivities?.map((taskActivity, index) => (
          <TaskActivityLink
            key={index}
            taskActivity={taskActivity}
            taskId={taskId}
            isCurrent={isCurrentActivity(
              taskActivity,
              currentTaskActivityId,
              currentActivityId,
              currentMiniactivityType
            )}
            feedbackParams={{
              dueDate,
              timeOffset,
            }}
          />
        ))}
      </div>
    </StyledTaskActivityNav>
  );
}

function TaskActivityLink({ taskActivity, taskId, isCurrent, feedbackParams }) {
  const url = getTaskActivityURL(taskId, taskActivity);

  return (
    <Link href={url}>
      <a className={`task-activity-link ${isCurrent ? 'current' : ''}`}>
        <div className="left">
          {isActivityDone(taskActivity.activityProgress) ? (
            <div className="done-icon">
              <Check size={pxToVw(30)} />
            </div>
          ) : (
            <ActivityTypeIcon
              type={taskActivity.activity.type}
              color="white"
              circleColor={
                Colors.activityTypeColors[taskActivity.activity.type]
              }
              withCircle
              size={pxToVw(15)}
              width={pxToVw(46)}
              height={pxToVw(46)}
            />
          )}
          <Text className={`activity-type-name ${isCurrent ? 'active' : ''}`}>
            {typeLabel(
              taskActivity.activity.type,
              taskActivity.activity.data.subType,
              taskActivity.activityConf.miniactivityType
            )}
            {taskActivity.activityConf.options.level ? (
              <Tag>
                {getLevelLabel(taskActivity.activityConf.options.level)}
              </Tag>
            ) : null}
          </Text>
          {/* {isCurrent ? <div className="indicator" /> : null} */}
        </div>
        <div className="right">
          {taskActivity.activityConf.progress ? (
            <ProgressFeedback
              repetitions={taskActivity.activityConf.options?.repetitions}
              activityProgress={taskActivity.activityProgress}
              showCorrect={taskActivity.activityConf.correctness}
              dueDate={feedbackParams.dueDate}
              timeOffset={feedbackParams.timeOffset}
              isStudent
              onlyGraph
              size="small"
            />
          ) : null}
        </div>
      </a>
    </Link>
  );
}

function isCurrentActivity(
  taskActivity,
  currentTaskActivityId,
  currentActivityId,
  currentMiniactivityType
) {
  return (
    taskActivity.id == currentTaskActivityId &&
    (currentMiniactivityType
      ? taskActivity.activityId == currentActivityId &&
        taskActivity.activityConf.miniactivityType == currentMiniactivityType
      : taskActivity.activityId == currentActivityId)
  );
}

export function isActivityDone(activityProgress) {
  return (
    activityProgress?.progressSlots &&
    activityProgress.progressSlots.length &&
    activityProgress.progressSlots.length == activityProgress.repetitions &&
    activityProgress.progressSlots.every((slot) => slot.progress == 100)
  );
}
